import type { ClaveEmitida } from "@/api/types"
import { SecretoUnaVez } from "@/shared/secreto-una-vez"

/**
 * La clave completa existe **solo** en la respuesta de alta: en la base de datos vive
 * el hash. Si el operador cierra sin copiarla, la única salida es emitir otra y revocar
 * esta.
 *
 * El comportamiento que lo evita —no cerrar con Escape, no habilitar el botón hasta
 * haber copiado— vive en `SecretoUnaVez`, compartido con el alta de personas. Es
 * relevante para la seguridad, y dos copias acabarían divergiendo justo en el detalle
 * que deja a alguien sin su credencial.
 */
export function KeyIssuedDialog({
  clave,
  onCerrar,
}: {
  clave: ClaveEmitida | null
  onCerrar: () => void
}) {
  return (
    <SecretoUnaVez
      abierto={clave !== null}
      titulo="Clave creada"
      subtitulo={clave === null ? undefined : `Prefijo ${clave.prefix}`}
      secreto={clave?.api_key ?? ""}
      tituloAviso="Cópiala ahora"
      aviso="No se puede volver a consultar. Si la pierdes, habrá que emitir otra y revocar esta."
      etiquetaCopiar="Copiar clave"
      etiquetaPendiente="Copia la clave para continuar"
      onCerrar={onCerrar}
    />
  )
}
